import React, { Component } from 'react'
import { connect } from 'react-redux'
import { path } from 'ramda'
import VideosList from 'Pages/Videos/List'
import WelcomeMessage from './WelcomeMessage'
import ProjectDashboard from './ProjectDashboard'
import styles from './HomeStyles'

class Home extends Component {
  render () {
    let home = null
    const projectId = path(['params', 'projectId'], this.props.match)
    if (!projectId || this.props.activeProject.id !== Number(projectId)) {
      home = <WelcomeMessage />
    } else if (this.props.userData.role === 'collaborator') {
      home = <VideosList {...this.props} />
    } else {
      home = <ProjectDashboard {...this.props} />
    }
    return <div className={styles.home}>{home}</div>
  }
}

const mapStateToProps = (state) => ({
  userData: state.auth.userData,
  activeTabBar: state.selections.activeTabBar,
  fetching: state.videos.listFetching,
  activeProject: state.selections.activeProject,
  rightSideBarVisible: state.selections.rightSideBarVisible
})

const mapDispatchToProps = () => ({
})

export default connect(mapStateToProps, mapDispatchToProps)(Home)



// WEBPACK FOOTER //
// ./src/Pages/Home/Home.js